import Vue from 'vue'
import Vuex from 'vuex'


const state = {
  list: [],
  alloc_list: [],
  total_alloc_list: [],
  num_gc_list: [],
  sys_list: [],
  time_list: [],
  online: 0
}

const getters = {
  do(state) {
    let len = state.list.length
    let result = {
      alloc_list: [],
      total_alloc_list: [],
      num_gc_list: [],
      sys_list: [],
      time_list: []
    };
    for (let i = 0; i < len; i++) {
      result.alloc_list.push(Number(state.list[i].alloc.toFixed(2)));
      result.total_alloc_list.push(Number(state.list[i].total_alloc.toFixed(2)));
      result.num_gc_list.push(Number(state.list[i].num_gc));
      result.sys_list.push(Number(state.list[i].sys.toFixed(2)));
      result.time_list.push(state.list[i].time);
    }
    return result
  },
  linkNum(state) {
    return state.online
  },
  averSys(state) {
    return getAverage(state.list, "sys");
  },
  averGc(state) {
    return getAverage(state.list, "num_gc")
  },
  averAlloc(state) {
    return getAverage(state.list, "alloc")
  }
}

const getAverage = (arr, idx = null) => {
  if (arr.length == 0) {
    return 0
  }

  let sum = 0;
  for (let index = 0; index < arr.length; index++) {
    if (idx) {
      sum += arr[index][idx]
    } else {
      sum += arr[index]
    }
  }
  return sum / arr.length
}

const actions = {}

const mutations = {
  addItem(state, value) {
    state.list = value.list
    state.online = value.link_num
  }
}

// Vue.use(Vuex)

// new Vuex.Store({
//   state: {
//     list: [],
//     alloc_list: [],
//     total_alloc_list: [],
//     num_gc_list: [],
//     sys_list: [],
//     time_list: []
//   },
//   getters: {
//     do(state) {
//       if (state.list.length > 10) {
//         for (let i = state.list.length - 10; i < state.list.length; i++) {
//           state.alloc_list.push(state.list[i].alloc.toFixed(2));
//           state.total_alloc_list.push(state.list[i].total_alloc);
//           state.num_gc_list.push(state.list[i].num_gc);
//           state.sys_list.push(state.list[i].sys);
//           state.time_list.push(state.list[i].time);
//         }
//       } else {
//         for (let i = 0; i < state.list.length; i++) {
//           state.alloc_list.push(state.list[i].alloc.toFixed(2));
//           state.total_alloc_list.push(state.list[i].total_alloc);
//           state.num_gc_list.push(state.list[i].num_gc);
//           state.sys_list.push(state.list[i].sys);
//           state.time_list.push(state.list[i].time);
//         }
//       }
//       console.log(state.alloc_list)

//     }
//   },
//   mutations: {
//     addItem(state, value) {
//       state.list = value.list
//       console.log(state.list)
//       console.log(typeof (state.list.list))
//     }
//   },
//   actions: {

//   },
//   modules: {}
// })


export default {
  state,
  mutations,
  actions,
  getters
};